export const NAVIGATOR_TARGET = 'addonmodule';
export const GLOBAL_MODULE_KEY = 'globalQuestionsViewer';
export const ADD_ON_KEY = 'com.atlassian.confluence.plugins.confluence-questions';
export const CONTENT_TYPE_PREFIX = `ac:${ADD_ON_KEY}`;
export const ANSWER_TYPE = `${CONTENT_TYPE_PREFIX}:answer`;
export const QUESTION_TYPE = `${CONTENT_TYPE_PREFIX}:question`;
export const GLOBAL_ROUTE_COOKIE_NAME = 'tmpGlobalRoute';
export const DEFAULT_PROFILE_PICTURE_URL =
	'/wiki/images/icons/profilepics/default.png?noRedirect=true';
